import { applyMiddleware, createStore, AnyAction } from 'redux';
import thunkMiddleware, { ThunkMiddleware } from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createMiddleware as abtestingMiddleware } from '@pegasus/abtesting';
import { reducer } from './reducer';
import { API_PREFIX } from '../../../shared/constants';

export function configureStore(initialState = {}) {
    const thunk: ThunkMiddleware<any, AnyAction> = thunkMiddleware;
    const abtesting = abtestingMiddleware({
        endpoint: `${API_PREFIX}/abtesting`,
    });
    const middlewares = applyMiddleware(abtesting, thunk);
    const store = createStore(reducer, initialState, composeWithDevTools(middlewares));

    return store;
}
